import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ApiService,
    Mk2Request,
    Mk2Response,
    Pagination
} from '@lsq-frontend/angular-shared/api-service';
import { ISettings, SETTINGS } from '@lsq-frontend/angular-shared/settings';

export class GetBuyerImplementationCompanyInformationRequest extends Mk2Request {
    buyerImplementationKey?: string;

    constructor(initial?: Partial<GetBuyerImplementationCompanyInformationRequest>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

export class GetBuyerImplementationCompanyInformationResponse extends Mk2Response {
    companyKey?: string;
    companyLegalName?: string;
    companyOrganizationType?:
        | 'UNKNOWN_COMPANY_ORGANIZATION_TYPE'
        | 'CORPORATION'
        | 'LLC'
        | 'PARTNERSHIP'
        | 'SOLE_PROPRIETORSHIP'
        | 'UNRECOGNIZED';
    companyPhoneNumber?: string;
    companyPreferredName?: string;
    companyWebsite?: string;
    dunsNumber?: string;
    ein?: string;
    experianBin?: string;
    formationDate?: any;
    formationState?: string;
    platformKey?: string;
    platformName?: string;
    servicesOverview?: string;
    sicCode?: string;

    constructor(initial?: Partial<GetBuyerImplementationCompanyInformationResponse>) {
        super();
        if (initial != null) {
            Object.keys(initial).forEach((key) => {
                this[key] = initial[key];
            });
        }
    }
}

@Injectable({ providedIn: 'root' })
export class GetBuyerImplementationCompanyInformationService extends ApiService<
    GetBuyerImplementationCompanyInformationRequest,
    GetBuyerImplementationCompanyInformationResponse
> {
    public requestType = GetBuyerImplementationCompanyInformationRequest;
    public responseType = GetBuyerImplementationCompanyInformationResponse;
    public endpointName =
        'operations/AdminManageBuyerImplementation/GetBuyerImplementationCompanyInformation';
    public serviceName = 'financing';
    constructor(http: HttpClient, @Inject(SETTINGS) settings: ISettings) {
        super(http, settings);
    }
}
